module.exports = __webpack_public_path__ + "static/media/alzucar-2.426cd522.png";